import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { useAuth } from '@/hooks/use-auth';
import { useIsSuperAdmin } from '@/hooks/use-is-super-admin';

const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
  </div>
);

// Single gate for the whole /admin area: waits for auth to load, then redirects anyone who
// is not a super-admin back to the app.
export function AdminRouteGuard({ children }: { children: ReactNode }) {
  const { loading } = useAuth();
  const isSuperAdmin = useIsSuperAdmin();
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (!loading && !isSuperAdmin) {
      setLocation('/');
    }
  }, [loading, isSuperAdmin, setLocation]);

  if (loading) {
    return <PageLoader />;
  }

  if (!isSuperAdmin) {
    return null;
  }

  return <>{children}</>;
}
